import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import { Heart } from 'lucide-react';
import { socialNetworks } from '../utils/socialNetworks';

const Footer = () => (
  <footer style={{
    padding: '50px 24px 30px 24px',
    backgroundColor: '#040810',
    color: 'var(--mga-slate-400)',
    borderTop: '1px solid rgba(255, 255, 255, 0.08)',
    position: 'relative',
    zIndex: 10
  }}>
    <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '24px',
        paddingBottom: '30px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.06)'
      }}>
        {/* Brand */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          <img
            src={logo}
            alt="Logo MonAlerte"
            style={{ height: '36px', width: 'auto', filter: 'drop-shadow(0 2px 8px rgba(242,184,7,0.3))' }}
          />
          <span style={{
            color: 'var(--mga-white)',
            fontWeight: 800,
            fontSize: '1.2rem',
            fontFamily: 'var(--font-display)'
          }}>
            Mon<span style={{ color: 'var(--mga-gold)' }}>Alerte</span>
          </span>
          <span style={{ fontSize: '0.85rem', color: 'var(--mga-slate-500)', marginLeft: '8px' }}>
            • Projet Technologique Citoyen
          </span>
        </div>

        {/* Icônes réseaux sociaux */}
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          {socialNetworks.map((net) => {
            const IconComp = net.icon;
            return (
              <a
                key={net.id}
                href={net.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={net.name}
                title={net.name}
                style={{
                  width: '38px',
                  height: '38px',
                  borderRadius: '10px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: `${net.color}18`,
                  border: `1px solid ${net.color}40`,
                  color: net.color,
                  transition: 'transform 0.2s ease',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
              >
                <IconComp size={18} />
              </a>
            );
          })}
        </div>

        {/* Links */}
        <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', fontSize: '0.9rem' }}>
          <Link to="/communaute" style={{ color: 'var(--mga-slate-300)', textDecoration: 'none', transition: 'color 0.2s ease' }}>
            Communauté & Réseaux
          </Link>
          <Link to="/politique-confidentialite" style={{ color: 'var(--mga-slate-300)', textDecoration: 'none', transition: 'color 0.2s ease' }}>
            Politique de confidentialité
          </Link>
          <Link to="/politique-confidentialite-enfant" style={{ color: 'var(--mga-slate-300)', textDecoration: 'none', transition: 'color 0.2s ease' }}>
            Politique MonAlerteEnfant
          </Link>
          <Link to="/contact" style={{ color: 'var(--mga-slate-300)', textDecoration: 'none', transition: 'color 0.2s ease' }}>
            Contact & Suppression de compte
          </Link>
        </div>
      </div>

      {/* Copyright */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px',
        marginTop: '25px',
        fontSize: '0.85rem',
        color: 'var(--mga-slate-500)'
      }}>
        <p style={{ margin: 0 }}>
          © {new Date().getFullYear()} MonAlerte. Tous droits réservés. Hébergé de manière souveraine en France.
        </p>

        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span>Conçu avec engagement pour la sécurité de tous</span>
          <Heart size={14} color="var(--mga-gold)" fill="var(--mga-gold)" />
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
